<div class="container-fluid pr-4">
	<div class="flex flex-row items-center justify-start gap-2">
		<div class="flex flex-auto flex-row items-center justify-start gap-2">
			<button
				(click)="zoomOut()"
				[disabled]="this.selectedSegment <= 2"
				[matTooltip]="'timer.calendar.zoomOut' | translate"
				mat-icon-button
			>
				<mat-icon>zoom_out</mat-icon>
			</button>
			<button
				(click)="zoomIn()"
				[disabled]="this.selectedSegment >= 12"
				[matTooltip]="'timer.calendar.zoomIn' | translate"
				mat-icon-button
			>
				<mat-icon>zoom_in</mat-icon>
			</button>
			<mat-divider vertical></mat-divider>
			<button
				(click)="todayView()"
				[disabled]="isLoading"
				mat-button
			>
				<mat-icon>today</mat-icon>
				<span class="ml-2">{{ 'timer.calendar.today' | translate }}</span>
			</button>
			<button
				(click)="prevView()"
				[disabled]="isLoading"
				mat-icon-button
			>
				<mat-icon>chevron_left</mat-icon>
			</button>
			<button
				(click)="rangePicker.toggle()"
				[disabled]="isLoading"
				[satPopoverAnchor]="rangePicker"
				mat-icon-button
			>
				<mat-icon>calendar_today</mat-icon>
			</button>
			<button
				(click)="nextView()"
				[disabled]="isLoading"
				mat-icon-button
			>
				<mat-icon>chevron_right</mat-icon>
			</button>
		</div>
		@if (this.selectedFeedEvents.value.length) {
		<button
			(click)="createMultipleTimes()"
			mat-raised-button
		>
			{{ 'feed.createEntries' | translate }}
		</button>
		<button
			(click)="clearFeedSelection()"
			[matTooltip]="'feed.clearSelection' | translate"
			mat-raised-button
		>
			<mat-icon>close</mat-icon>
		</button>
		}
		<div class="flex flex-row items-center justify-start gap-1.5">
			<h3>
				{{ viewDate | dfnsStartOfISOWeek | dfnsFormat: 'MMM dd' : { weekStartsOn: weekStartsOn } }}-
				{{ viewDate | dfnsEndOfISOWeek | dfnsFormat: 'MMM dd' : { weekStartsOn: weekStartsOn } }}(
				{{ 'timer.calendar.kw' | translate: { value: (viewDate | dfnsGetISOWeek) } }})
			</h3>
			<button
				[matMenuTriggerFor]="calendarOptions"
				[matTooltip]="'timer.calendar.settings' | translate"
				mat-icon-button
				tabindex="-1"
			>
				<mat-icon>settings</mat-icon>
			</button>
		</div>
	</div>
</div>
<ng-template
	#weekViewHourSegmentTemplate
	let-isTimeLabel="isTimeLabel"
	let-segment="segment"
	let-segmentHeight="segmentHeight"
>
	<div
		(mousedown)="startDragToCreate(segment, $event, segmentElement)"
		[class.cal-after-hour-start]="!segment.isStart"
		[class.cal-hour-start]="segment.isStart"
		[ngClass]="segment.cssClass"
		[style.height.px]="segmentHeight"
		#segmentElement
		class="cal-hour-segment"
	>
		<div
			*ngIf="isTimeLabel"
			class="cal-time"
		>
			{{ segment.date | formatDate: 'time' }}
		</div>
	</div>
</ng-template>
<ng-template
	#tgEvent
	let-column="column"
	let-daysInWeek="daysInWeek"
	let-eventClicked="eventClicked"
	let-tooltipAppendToBody="tooltipAppendToBody"
	let-tooltipDelay="tooltipDelay"
	let-tooltipDisabled="tooltipDisabled"
	let-tooltipPlacement="tooltipPlacement"
	let-tooltipTemplate="tooltipTemplate"
	let-weekEvent="weekEvent"
>
	<mat-card
		(contextmenu)="weekEvent.event.meta?.loading === true || !!weekEvent.event.meta?.feed || onContextMenu($event, weekEvent)"
		(mwlClick)="weekEvent.event.meta?.loading === true || weekEvent.event.meta?.time?.project?.completed || eventClicked.emit({ sourceEvent: $event })"
		(mwlKeydownEnter)="weekEvent.event.meta?.loading === true || weekEvent.event.meta?.time?.project?.completed || eventClicked.emit({ sourceEvent: $event })"
		[matTooltipDisabled]="weekEvent.event.meta?.tmpEvent"
		[matTooltipTemplate]="eventViewTooltip"
		[matTooltipTemplateContext]="{
      $implicit: weekEvent,
      daysInWeek: daysInWeek,
    }"
		[ngClass]="{
      'cursor-default! opacity-60': weekEvent.event.meta?.time?.project?.completed,
      'tg-event-item-billable': weekEvent.event?.meta?.time?.billable === true,
      'tg-event-item-outlook': weekEvent.event?.meta?.type === 'calendar',
    }"
		class="tg-event-item pos-relative select-none"
		matTooltip
		role="button"
		tabindex="0"
	>
		<app-loader
			[enableCircle]="true"
			[isActive]="weekEvent.event.meta?.loading === true"
			[width]="24"
		></app-loader>
		<div
			*ngIf="weekEvent.event.meta.tmpEvent; else timeView"
			class="truncate"
		>
			{{ weekEvent.event?.title || '' }}
		</div>
		<ng-template #timeView>
			<ng-container *ngIf="weekEvent.event.meta.time as time">
				<div
					[style.backgroundColor]="color"
					*ngIf="this.getProjectColor(time.project.id) as color"
					class="project-card-color"
				></div>
				<div
					*ngIf="time.name"
					class="truncate"
				>
					{{ time.name }}
				</div>
				<div class="flex flex-row items-baseline justify-start gap-1.5">
					<div
						[style.backgroundColor]="color"
						*ngIf="this.getProjectColor(time.project.id) as color"
						class="project-color-dot project-color-dot-calendar"
					></div>
					<div>{{ time.project | defaultEntityTranslate: 'project' : 'project.none' }}</div>
				</div>
				<div class="flex flex-col">
					<small *ngIf="time.inputMode !== 'duration'">
						{{ weekEvent.event.start | formatDate: 'time' }}-{{
							weekEvent.event.end | formatDate: 'time'
						}}</small
					>
					<small *ngIf="weekEvent.event.meta.outlook"
						>{{ 'timer.calendar.created-from' | translate }}Outlook</small
					>
				</div>
			</ng-container>
			<ng-container *ngIf="weekEvent.event.meta.feed as time">
				<div class="flex flex-row items-start justify-start gap-1">
					<div
						[ngClass]="'bg-black dark:bg-white'"
						*ngIf="isSelectedEvent(time.id)"
						class="project-card-color"
					></div>
					<div
						*ngIf="weekEvent.event.meta.type === 'calendar'"
						class="project-feed-icon mt-1 flex-shrink-0"
					>
						<img
							alt="outlook logo"
							src="/assets/svg/icons/outlook.svg"
						>
					</div>
					<div>{{ time.name }}</div>
				</div>
				<small>
					{{ weekEvent.event.start | formatDate: 'time' }}-{{
						weekEvent.event.end | formatDate: 'time'
					}}</small
				>
			</ng-container>
		</ng-template>
	</mat-card>
</ng-template>
<ng-template
	#tgHourTemplate
	let-daysInWeek="daysInWeek"
	let-isTimeLabel="isTimeLabel"
	let-locale="locale"
	let-segment="segment"
	let-segmentHeight="segmentHeight"
>
	<div
		[attr.aria-hidden]="{} | calendarA11y: (daysInWeek === 1 ? 'hideDayHourSegment' : 'hideWeekHourSegment')"
		[class.cal-after-hour-start]="!segment.isStart"
		[class.cal-hour-start]="segment.isStart"
		[ngClass]="segment.cssClass"
		[style.height.px]="segmentHeight"
		class="cal-hour-segment"
	>
		<div
			*ngIf="isTimeLabel"
			class="cal-time"
		>
			{{ segment.displayDate | formatDate: 'time' }}
		</div>
	</div>
</ng-template>
<div class="tgc-wrapper">
	<app-loader
		[enableCircle]="true"
		[isActive]="this.isLoading$ | async"
		[width]="24"
	></app-loader>
	<mwl-calendar-week-view
		(eventClicked)="this.onEventClicked($event, $event)"
		(eventTimesChanged)="this.eventTimesChanged($event)"
		[dayEndHour]="23"
		[dayStartHour]="startFromWorkDay ? 6 : 0"
		[eventSnapSize]="this.selectedSegmentSnapSize"
		[events]="events$ | async"
		[eventTemplate]="tgEvent"
		[headerTemplate]="eventWeekHeader"
		[hourSegments]="this.selectedSegment"
		[hourSegmentTemplate]="weekViewHourSegmentTemplate"
		[refresh]="this.viewRefresh"
		[viewDate]="viewDate"
		[weekStartsOn]="1"
		#mwlCal
		class="cal-week-view-host"
	></mwl-calendar-week-view>
</div>
<ng-template
	#eventWeekHeader
	let-dayHeaderClicked="dayHeaderClicked"
	let-days="days"
	let-dragEnter="dragEnter"
	let-eventDropped="eventDropped"
	let-locale="locale"
	let-trackByWeekDayHeaderDate="trackByWeekDayHeaderDate"
>
	<div
		class="cal-day-headers"
		role="row"
	>
		<div
			[class.cal-future]="day.isFuture"
			[class.cal-past]="day.isPast"
			[class.cal-today]="day.isToday"
			[class.cal-weekend]="day.isWeekend"
			[ngClass]="day.cssClass"
			*ngFor="let day of days; trackBy: trackByWeekDayHeaderDate"
			class="cal-header flex select-none flex-col"
			role="columnheader"
			tabindex="0"
		>
			<div class="flex flex-row items-center justify-start">
				<div class="flex flex-auto flex-col text-left">
					<b>{{ day.date | dfnsFormat: 'EEEE' }}</b>
					<span>{{ day.date | dfnsFormat: 'MMM dd' }}</span>
				</div>
				<ng-container *ngIf="getStatsFromDate(day) as sched">
					<ng-container *ngTemplateOutlet="scheduleView; context: { $implicit: sched }"></ng-container>
				</ng-container>
			</div>
		</div>
	</div>
</ng-template>
<ng-template
	#eventViewTooltip
	let-daysInWeek="daysInWeek"
	let-weekEvent
>
	<div class="px-1 py-1.5">
		<ng-container *ngIf="weekEvent.event?.meta?.time?.id && weekEvent.event as ev">
			<div class="flex flex-col">
				<div>
					{{
						ev.title | calendarEventTitle: (daysInWeek === 1 ? 'dayTooltip' : 'weekTooltip') : weekEvent.tempEvent || weekEvent.event
					}}
				</div>
				<div class="flex flex-row items-center justify-start gap-1">
					<span>{{ ev.meta.time.project | defaultEntityTranslate: 'project' : 'project.none' }}</span>
					<ng-container *ngIf="ev.meta.time.task as task">
						<div class="mat-bg-30 h-1 w-1 rounded-full"></div>
						<span>{{ task.name | truncate: 25 }}</span>
					</ng-container>
				</div>
				<div class="flex items-center space-x-0.5">
					<span class="mat-hint italic">{{ ev.meta.time.timeDiff | parseMsAsDuration }}</span>
					<ng-container *ngIf="ev.meta.time?.inputMode !== 'duration'">
						<span>-</span>
						<span>({{ ev.start | formatDate: 'time' }}- {{ ev.end | formatDate: 'time' }})</span>
					</ng-container>
				</div>
				<div *ngIf="ev.meta.time.billable">{{ 'Billable_Alt' | translate }}</div>
			</div>
		</ng-container>
		<ng-container *ngIf="weekEvent.event?.meta?.feed && weekEvent.event as ev">
			<div class="flex flex-row items-center justify-start gap-1">
				<div
					*ngIf="weekEvent.event.meta.type === 'calendar'"
					class="project-feed-icon"
				>
					<img
						alt="outlook logo"
						src="/assets/svg/icons/outlook.svg"
					>
				</div>
				<div class="flex flex-col space-y-0.5">
					<div>
						{{
							ev.title | calendarEventTitle: (daysInWeek === 1 ? 'dayTooltip' : 'weekTooltip') : weekEvent.tempEvent || weekEvent.event
						}}
					</div>
					<div class="flex items-center space-x-0.5">
						<span class="mat-hint italic">{{
							ev.start | dfnsDifferenceInSeconds: ev.end | parseMsAsDuration
						}}</span>
						<ng-container *ngIf="ev.meta.time?.inputMode !== 'duration'">
							<span>-</span>
							<span>({{ ev.start | formatDate: 'time' }}- {{ ev.end | formatDate: 'time' }})</span>
						</ng-container>
					</div>
					<mat-hint translate>timer.calendar.multiSelectionHint</mat-hint>
				</div>
			</div>
		</ng-container>
	</div>
</ng-template>
<mat-menu #eventContextMenu="matMenu">
	<ng-template
		let-event="event"
		matMenuContent
	>
		<button
			(click)="this.onEventClicked({ event: event })"
			[disabled]="event.meta.time?.project?.completed || !event.draggable"
			mat-menu-item
		>
			{{ 'timer.calendar.eventContext.edit' | translate }}
		</button>
		<button
			(click)="this.duplicateEvent(event)"
			[disabled]="event.meta.time?.project?.completed || !event.draggable"
			mat-menu-item
		>
			{{ 'timer.calendar.eventContext.duplicate' | translate }}
		</button>
		<button
			(click)="this.removeEvent(event)"
			[disabled]="event.meta.time?.project?.completed || !event.draggable"
			class="text-warn"
			mat-menu-item
		>
			{{ 'timer.calendar.eventContext.remove' | translate }}
		</button>
	</ng-template>
</mat-menu>
<mat-menu #calendarOptions="matMenu">
	<ng-template matMenuContent>
		<mat-card
			(click)="$event.stopPropagation()"
			class="mat-elevation-z0 flex flex-col gap-1"
		>
			<mat-checkbox
				(change)="this.startFromWorkDay = $event.checked"
				[checked]="this.startFromWorkDay"
				color="primary"
			>
				{{ 'timer.calendar.showWorkHours' | translate }}
			</mat-checkbox>
		</mat-card>
	</ng-template>
</mat-menu>
<div
	[matMenuTriggerFor]="eventContextMenu"
	[style.left]="contextMenuPosition.x"
	[style.top]="contextMenuPosition.y"
	#eventContextTrigger="matMenuTrigger"
	style="visibility: hidden; position: fixed"
></div>
<tg-time-tracker-calendar-week-picker
	(rangeChange)="selectView($event)"
	[viewDate]="viewDate"
	#rangePicker
></tg-time-tracker-calendar-week-picker>
<ng-template
	#scheduleView
	let-sched
>
	<div
		[matTooltipTemplate]="scheduleTooltip"
		[matTooltipTemplateContext]="{ $implicit: sched }"
		class="mat-typography mat-bg-5-hover grid h-12 grid-cols-[1fr_28px] items-center gap-x-3 rounded-lg px-4"
		matTooltip
	>
		<div class="flex flex-col text-right text-sm">
			<span>{{ sched.current.used | parseMsAsDuration }}</span>
			<span>{{ sched.current.max | parseMsAsDuration }}</span>
		</div>
		<div class="mat-circle-card">
			<mat-progress-spinner
				[color]="sched.graphState"
				[diameter]="20"
				[value]="sched.current.percent * 100 | clamp: 0 : 100"
				class="with-back-spinner"
				strokeWidth="3"
			></mat-progress-spinner>
		</div>
	</div>
</ng-template>
<ng-template
	#scheduleTooltip
	let-sched
>
	<div class="mat-typography flex flex-col px-3 py-2.5">
		<div class="flex items-center space-x-2">
			<span>{{ sched.name || (scheduleNameToolip$ | async | translate) }}</span>
			<ng-container *ngIf="sched.current.percent >= 0">
				<span class="dot size-1.5"></span>
				<span>{{ sched.current.percent | percent }}</span>
			</ng-container>
		</div>
	</div>
</ng-template>
